import Box from '@mui/material/Box';
import { ReactNode } from 'react';
import { Typography, colors } from '@sweep-io/sweep-design';

export const DetailsWrapperWithHeader = ({
  headerTxt,
  children,
}: {
  headerTxt: string;
  children: ReactNode;
}) => (
  <Box display="flex" flexDirection="column" gap={0.5} minWidth={0}>
    <Box display="flex" alignItems="center">
      <Typography variant="body-medium" color={colors.grey[900]}>
        {headerTxt}
      </Typography>
    </Box>
    <Box display="inline-flex" alignItems="center" minWidth={0}>
      {children}
    </Box>
  </Box>
);
